import React from 'react'
import useAuthComponent from '@/hooks/useAuthComponent'

export default function withCheckAuthorization<P extends Record<string, unknown>>(
  Component: React.ComponentType<P>,
  NoAuthComponent: React.ComponentType<P> = () => <></>
): React.FC<
  P & {
    authCode: string
  }
> {
  return function CheckAuthorize(props) {
    const { authCode, ...rest } = props
    const hasAuth = useAuthComponent(authCode)

    return hasAuth ? <Component {...(rest as P)} /> : <NoAuthComponent {...(rest as P)} />
  }
}
